import { Directive, Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Directive()
@Injectable({
  providedIn: 'root',
})
export class AppMemoryService extends BehaviorSubject<any> {
  appData: any = {};

  private apiStatusSub = new BehaviorSubject(false);
  apiStatus = this.apiStatusSub.asObservable();
  apiCompleted: any = {};

  constructor() {
    super(null);
    this.appData = {};
  }

  setApiStatus = (key, status) => {
    this.apiCompleted[key] = status;
    if (status === true) {
      this.apiStatusSub.next(this.apiCompleted);
    }
  };

  getApiStatus = (key) => {
    return this.apiCompleted[key];
  };

  setData = (key, value) => {
    // to enable UI side caching comment below return statement
    // to disable UI side caching uncomment below return statement

    // return;
    this.appData[key] = value;
  };

  getData = (key) => {
    return this.appData[key];
  };
}

export const DATA_KEY = {
  ROLE_MASTER_DATA: 'ROLE_MASTER_DATA',
};
